import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Appbar from "../components/Appbar";
import { getToken } from "../slice/tokenSlice";
import { setUser, setStep } from "../slice/userSlice";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";

export default function Auth({ Component }) {
  const dispatch = useDispatch();
  const { error } = useSelector((state) => state.token);
  const appbar = useSelector((state) => state.appbar);
  const { url, user, welcomeDone } = useSelector((state) => state.user);
  //
  const navigate = useNavigate();
  const location = useLocation();

  const auth = async () => {
    try {
      const storedUser = localStorage.getItem("sml-platform-user");
      if (!storedUser) {
        navigate("/login", { replace: true });
      }

      const token = await dispatch(getToken());
      const userId = JSON.parse(storedUser);
      const res = await axios.get(
        `${url}/proxy?url=https://www.zohoapis.in/crm/v2/Leads/${userId}`,
        {
          headers: {
            Authorization: `Zoho-oauthtoken ${token.payload}`,
          },
        },
      );

      if (res.status === 204) {
        const newToken = await test();
        if (newToken) {
          auth();
        } else {
          localStorage.removeItem("sml-platform-user");
          navigate("/login", { replace: true });
        }
      } else if (res.status === 200) {
        const data = { ...res.data.data[0] };
        Object.keys(data).forEach((key) => {
          data[key] = data[key] ?? "";
        });
        dispatch(setUser(data));
        dispatch(setStep(data.Step?.toString() || ""));
        //
        if (
          data.Account_Status.toLowerCase() === "inactive" ||
          data.Account_Status.toLowerCase() === "terminate"
        ) {
          navigate("/login", { replace: true });
        } else if (data.Account_Status.toLowerCase() === "enrolled") {
          const res2 = await axios.get(
            `${url}/proxy?url=https://www.zohoapis.in/crm/v2/Enrollment_Fees/search?criteria=((Lead_Name:equals:${data.id}))`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Zoho-oauthtoken ${token.payload}`,
              },
            },
          );
          if (
            res2.status === 200 &&
            res2.data?.data[0].Payment_Status.toLowerCase() === "paid"
          ) {
            navigate("/user_cibil");
          } else {
            const step = data.Step?.toString();
            if (step !== "4") {
              navigate("/steps", { replace: true });
            } else {
              if (data.Payment_Status.toLowerCase() === "paid") {
                navigate(`/thankyou/${data.Transaction_Reference_No}`, {
                  replace: true,
                });
              }
            }
          }
        } else if (data.Account_Status.toLowerCase() === "active") {
          return;
        }
      }
    } catch (err) {
      console.error("Auth error:", err);
    }
  };

  async function test() {
    try {
      console.log("object");
      const res = await axios.get(`${url}/token/generate`);
      return res.data.newToken.token;
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    auth();
  }, [location.pathname, welcomeDone]);

  const hideAppbarRoutes = ["/welcome", "/steps", "/thankyou", "/user_cibil"];
  const shouldHideAppbar =
    user?.Account_Status.toLowerCase() === "enrolled" &&
    hideAppbarRoutes.some((route) => location.pathname.startsWith(route));

  if (error) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center py-4">
        <p>{error}</p>
      </div>
    );
  }

  return user ? (
    <>
      <div className="main-flex">
        {!shouldHideAppbar && (
          <div
            className={`app-bar-wrapper  ${appbar === true ? "active" : ""}`}
            style={{ position: "sticky", top: 0 }}
          >
            <Appbar />
          </div>
        )}
        <div
          className={`main-component ${
            appbar === true ? "hide-main-component" : ""
          }`}
        >
          <div className="p-2">
            <Navbar />
            <div className="bg-white rounded shadow-sm px-2 py-4">
              <div className="container p-0">
                <Component />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : null;
}
